export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/chevron-left-6f3b5eefd3c0e8a8d18090afcde779ca.svg";